import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import {AudioVideoSubcategoryTypeEnum} from '../interfaces/audio-video.model';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.Writing,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Writing',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>These videos show you how you could answer some of your writing questions — we\'ve used our best handwriting especially!</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Writing Video Solutions',
        Intro:
          'Use these videos to help you find out how to approach some of the writing questions in your book.',
        LeftSections: [
          {
            Header: 'Section One — General Stuff',
            Subcategories: [
              {
                Name: 'Numbers, Times, Days and Dates — Q1',
                ShortName: 'Numbers-Times-Days-and-Dates-Q1',
                Link: 'https://www.youtube.com/embed/zenOVbXWRAw?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Three — Healthy Living',
            Subcategories: [
              {
                Name: 'Physical & Mental Wellbeing and Illnesses & Treatments — Q4 (Foundation)',
                ShortName:
                  'Physical-and-Mental-Wellbeing-and-Illnesses-and-Treatments-Q4-Foundation',
                Link: 'https://www.youtube.com/embed/IEE18H_tDuw?rel=0&modestbranding=1',
              },
              {
                Name: 'Physical & Mental Wellbeing and Illnesses & Treatments — Q4 (Higher)',
                ShortName: 'Physical-and-Mental-Wellbeing-and-Illnesses-and-Treatments-Q4-Higher',
                Link: 'https://www.youtube.com/embed/N3hfbUJbwDQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Themes 1 and 2 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Themes 1 and 2 Mixed Practice Foundation — Q3',
                ShortName: 'Themes-1-and-2-Mixed-Practice-Foundation-Q3',
                Link: 'https://www.youtube.com/embed/V5ueSNBMifY?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Themes 3 and 4 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Themes 3 and 4 Mixed Practice Higher — Q2',
                ShortName: 'Themes-3-and-4-Mixed-Practice-Higher-Q2',
                Link: 'https://www.youtube.com/embed/lYCcN0E51_E?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Themes 5 and 6 Mixed Practice Higher — Q3',
            Subcategories: [
              {
                Name: 'Themes 5 and 6 Mixed Practice Higher — Q3',
                ShortName: 'Themes-5-and-6-Mixed-Practice-Higher-Q3',
                Link: 'https://www.youtube.com/embed/VBR7ZSQpBa0?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Reading,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Reading',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Watch us work through some of the reading questions in your book.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Reading Video Solutions',
        Intro:
          'Our experts work through some of the reading questions in your book — take your pick!',
        LeftSections: [
          {
            Header: 'Section Two — Identity and Relationships with Others',
            Subcategories: [
              {
                Name: 'About Yourself and My Family & Friends — Q2',
                ShortName: 'About-Yourself-and-My-Family-and-Friends-Q2',
                Link: 'https://www.youtube.com/embed/tq0uSmzIgDQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Four — Free-time Activities',
            Subcategories: [
              {
                Name: 'Sports, Going Out and Other Hobbies — Q4',
                ShortName: 'Sports-Going-Out-and-Other-Hobbies-Q4',
                Link: 'https://www.youtube.com/embed/0uruNY9T1XA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Themes 1 and 2 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Themes 1 and 2 Mixed Practice Both Tiers — Q1',
                ShortName: 'Themes-1-and-2-Mixed-Practice-Both-Tiers-Q1',
                Link: 'https://www.youtube.com/embed/CUOUxKzZB5M?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Five — Places in Town',
            Subcategories: [
              {
                Name: 'Where You Live and At Home — Q3',
                ShortName: 'Where-You-Live-and-At-Home-Q3',
                Link: 'https://www.youtube.com/embed/xJRdOBNQeXQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Seven — Social Media and Technology',
            Subcategories: [
              {
                Name: 'Social Media — Q3',
                ShortName: 'Social-Media-Q3',
                Link: 'https://www.youtube.com/embed/fZaIpXGpqRY?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eight — School',
            Subcategories: [
              {
                Name: 'School Pressures and Difficulties — Q4',
                ShortName: 'School-Pressures-and-Difficulties-Q4',
                Link: 'https://www.youtube.com/embed/UvkhRigFQqk?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro:
        '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ListeningTracks,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Listening',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>You\'ve hit the listening jackpot — here\'s all the audio you\'ll need for your listening questions.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio for all listening questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Audio',
      Intro: 'Choose a listening question in your book and find the matching audio track below!',
      ProductTitle: 'GCSE Edexcel Spanish Exam Practice Workbook',
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/01-listening-track-01-numbers-times-days-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/02-listening-track-02-numbers-times-days-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/03-listening-track-03-questions-and-being-polite.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/04-listening-track-04-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/05-listening-track-05-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/06-listening-track-06-about-yourself-and-my-family-friends.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/07-listening-track-07-about-yourself-and-my-family-friends.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/08-listening-track-08-describing-people-and-relationships.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/09-listening-track-09-role-models-and-celebrations.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/10-listening-track-10-role-models-and-celebrations.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/11-listening-track-11-food.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/12-listening-track-12-food.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/13-listening-track-13-physical-mental-wellbeing-and-illnesses-treatments.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/14-listening-track-14-music-cinema-and-tv.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/15-listening-track-15-music-cinema-and-tv.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/16-listening-track-16-sports-going-out-and-other-hobbies.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/17-listening-track-17-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/18-listening-track-18-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/19-listening-track-19-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/20-listening-track-20-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/21-listening-track-21-where-you-live-and-at-home.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/22-listening-track-22-the-local-area.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/23-listening-track-23-the-local-area.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/24-listening-track-24-environmental-problems-effects-and-protection.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/25-listening-track-25-equality-and-social-issues.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/26-listening-track-26-technology-the-internet-and-streaming.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/27-listening-track-27-social-media.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/28-listening-track-28-social-media.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/29-listening-track-29-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/30-listening-track-30-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/31-listening-track-31-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/32-listening-track-32-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/33-listening-track-33-school-subjects-and-school-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/34-listening-track-34-school-subjects-and-school-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/35-listening-track-35-school-pressures-and-difficulties.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/36-listening-track-36-education-post-16-and-career-choices-ambitions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/37-listening-track-37-where-to-go-and-accommodation-travel.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/38-listening-track-38-tourist-attractions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/39-listening-track-39-tourist-attractions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/40-listening-track-40-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/41-listening-track-41-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/42-listening-track-42-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/43-listening-track-43-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/44-listening-track-44-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/listening/45-listening-track-45-mixed-practice-higher.mp3',
      ],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Speaking,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio and videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Speaking',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>All the audio for your speaking questions and some example answers from our speaking pros — let\'s go!</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio and example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro:
        'Check out the audio for the speaking questions in your book or take a look at our handy videos, which give you some example answers.',
      Title: 'Speaking Audio and Video Solutions',
      LeftSections: [
        {
          Title: 'Speaking Audio',
          Header: '',
          Subcategories: [
            {
              Name: 'Audio Support',
              Link: '',
              LinkName: '',
              Description:
                'Choose a speaking question in your book and find the matching audio track below!',
              Type: AudioVideoSubcategoryTypeEnum.Audio,
              TrackFilePaths: [
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/01-speaking-track-01-opinions.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/02-speaking-track-02-describing-people-and-relationships.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/03-speaking-track-03-physical-mental-wellbeing-and-illnesses-treatments.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/04-speaking-track-04-sports-going-out-and-other-hobbies.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/05-speaking-track-05-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/06-speaking-track-06-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/07-speaking-track-07-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/08-speaking-track-08-where-you-live-and-at-home.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/09-speaking-track-09-shopping-directions-and-weather.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/10-speaking-track-10-equality-and-social-issues.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/11-speaking-track-11-technology-the-internet-and-streaming.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/12-speaking-track-12-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/13-speaking-track-13-mixed-practice-both-tiers.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/14-speaking-track-14-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/15-speaking-track-15-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/16-speaking-track-16-school-subjects-and-school-life.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/17-speaking-track-17-education-post-16-and-career-choices-ambitions.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/18-speaking-track-18-where-to-go-and-accommodation-travel.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/19-speaking-track-19-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/20-speaking-track-20-mixed-practice-both-tiers.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPEQ42/Audio/speaking/21-speaking-track-21-mixed-practice-higher.mp3',
              ],
            },
          ],
        },
        {
          Title: 'Speaking Video Solutions',
          Header: 'Themes 1 and 2 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Themes 1 and 2 Mixed Practice Higher — Q1',
              Link: 'https://www.youtube.com/embed/woQTHXGG8Js?rel=0&modestbranding=1',
              LinkName: 'themes-1-and-2-mixed-practice-higher-q1',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Five — Places in Town',
          Subcategories: [
            {
              Name: 'Shopping, Directions and Weather — Q1',
              Link: 'https://www.youtube.com/embed/Y2elBFqVcXo?rel=0&modestbranding=1',
              LinkName: 'shopping-directions-and-weather-q1',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Six — Environmental and Social Issues\n',
          Subcategories: [
            {
              Name: 'Equality and Social Issues — Q3',
              Link: 'https://www.youtube.com/embed/2patWJMynvw?rel=0&modestbranding=1',
              LinkName: 'equality-and-social-issues-q3',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Seven — Social Media and Technology',
          Subcategories: [
            {
              Name: 'Technology, The Internet and Streaming — Q1',
              Link: 'https://www.youtube.com/embed/kz3zBXYUvE8?rel=0&modestbranding=1',
              LinkName: 'technology-the-internet-and-streaming-q1',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Ten — Travel and Tourism',
          Subcategories: [
            {
              Name: 'Where to Go and Accommodation & Travel — Q4',
              Link: 'https://www.youtube.com/embed/w324MwLFSVo?rel=0&modestbranding=1',
              LinkName: 'where-to-go-and-accommodation-and-travel-q4',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Themes 5 and 6 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Themes 5 and 6 Mixed Practice Foundation — Q2',
              Link: 'https://www.youtube.com/embed/VpgMZEMNDLs?rel=0&modestbranding=1',
              LinkName: 'themes-5-and-6-mixed-practice-foundation-q2',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
      ],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, transcripts, and vocabulary lists — yep, it's all right here. </p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<h3>Speaking</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPEQ42/PDFs/2619_SP4P0053_Speaking_Transcripts.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Transcripts</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPEQ42/PDFs/2619_SP4P0054_Speaking_Mark_Schemes.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Mark Schemes</a></p>\n' +
        '\n' +
        '<h3>Listening</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPEQ42/PDFs/2619_SP4P0052_Listening_Transcripts.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Transcripts</a></p>\n' +
        '\n' +
        '<h3>Writing</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPEQ42/PDFs/2619_SP4P0055_Writing_Mark_Schemes.pdf" style="color: rgb(20, 148, 212);" target="_blank">Writing Mark Schemes</a></p>\n' +
        '\n' +
        '<p>&nbsp;</p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
];

